import type { PostHogConfig } from "posthog-js";
import { PostHogProvider as BasePostHogProvider } from "posthog-js/react";
import * as React from "react";
import { getMobileVersionTelemetry } from "~/config/capacitor/mobile-version";
import { env } from "~/config/env";

interface PostHogProviderProps {
  children?: React.ReactNode;
}

export function PostHogProvider({ children }: PostHogProviderProps) {
  const options: Partial<PostHogConfig> = {
    api_host: env.VITE_PUBLIC_POSTHOG_HOST,
    loaded: (posthog) => {
      const mobileVersionTelemetry = getMobileVersionTelemetry(window.appInfos);
      posthog.register(mobileVersionTelemetry);
    },
  };

  return (
    <BasePostHogProvider apiKey={env.VITE_PUBLIC_POSTHOG_KEY} options={options}>
      {children}
    </BasePostHogProvider>
  );
}
